// About.jsx
// Page that tells the story of Saaj Fashion Art

import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/About.css';

function About() {
  const { t } = useLanguage();

  return (
    <div className="about-page">
      <section className="about">
        <div className="about-content">
          {/* Page Title */}
          <h2 className="section-title">{t.about.title}</h2>
          <p className="section-subtitle">{t.about.subtitle}</p>
          
          {/* About Text */}
          <div className="about-text">
            <p>{t.about.para1}</p>
            <p>{t.about.para2}</p>
          </div>

          {/* Statistics Section */}
          <div className="stats-container">
            {/* Stat 1 - Experience */}
            <div className="stat-item">
              <div className="stat-number">10+</div>
              <div className="stat-label">{t.about.stats.experience}</div>
            </div>
            
            {/* Stat 2 - Customers */}
            <div className="stat-item">
              <div className="stat-number">5000+</div>
              <div className="stat-label">{t.about.stats.customers}</div>
            </div>
            
            {/* Stat 3 - Custom Designs */}
            <div className="stat-item">
              <div className="stat-number">100%</div>
              <div className="stat-label">{t.about.stats.designs}</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;

/*
LEARNING POINT - COMPONENT COMPOSITION:

Notice how this page is simple and clean?
That's because we're just displaying content, not managing complex logic.

In React, we separate:
1. PRESENTATIONAL COMPONENTS (like this)
   - Just display data
   - Receive data via props or context
   - Simple and easy to understand

2. CONTAINER COMPONENTS (like App.js)
   - Handle logic and state
   - Pass data to presentational components
   - More complex

This separation makes code easier to:
- Read
- Test
- Maintain
- Reuse
*/
